interface IEmojiCategory {
	title: string,
	icon: string,
	groupId: number,
	items: IEmojiData[],
}

interface IEmojiData {
	annotation: string,
	emoji: string,
	group: number,
	order: number,
	shortcodes: string[],
	skins: any,
	tags: string[],
	version: number
}

export type EmojiChar = { name: string; char: string; };
export type EmojiGroup = { name: string; emojis: EmojiChar[] };

let resolve;
let loaded = false;
export const emojiGroups$ = new Promise<EmojiGroup[]>(r => resolve = r);
export const DefaultEmojis = [
	{ char: '😀', name: 'Smile' },
	{ char: '👎', name: 'Thumbs Down' },
	{ char: '👏', name: 'Clapping Hands' },
	{ char: '❤️', name: 'Heart' },
	{ char: '👍', name: 'Thumbs Up' }
];

//loads emoji characters and names from the ckeditor emoji plugin at runtime.
//Called automatically from ckeditor the first time it loads.
export function loadEmoji(emojiPlugin: any): void {
	if(loaded) {
		return;
	}

	const result: IEmojiCategory[] = emojiPlugin.getEmojiCategories();
	const formattedCategories = result.map((ec: IEmojiCategory) => {
		const formattedList = ec.items.map((ed: IEmojiData) => {
			return {
				name: ed.annotation,
				char: ed.emoji
			} as EmojiChar;
		});
		return {
			name: ec.title,
			emojis: formattedList
		} as EmojiGroup;
	});

	loaded = true;
	resolve(formattedCategories);
}
